<div class="apps-book-widget">
  <idp-guided-navigation-error
    class="apps-book-widget__guided-error"
    *ngIf="guidedNavigationErrorMsg"
    [errorMessage]="guidedNavigationErrorMsg"
  ></idp-guided-navigation-error>
  <ng-container
    [ngTemplateOutlet]="isDesktop ? desktopView : mobileView"
  ></ng-container>
  <ng-template #desktopView>
    <ng-container
      *ngIf="
        isBookWidgetReady && bookWidgetFields && bookWidgetAem;
        else desktopSkeleton
      "
    >
      <idp-apps-book-widget-desktop-ow-rt
        *ngIf="
          bookWidgetFields?.tripTypesField?.selectedTripType !==
          tripTypeOptions.MULTI_CITY
        "
        (infoIconClick)="infoIconClickHandler($event)"
        [bookWidgetFields]="bookWidgetFields"
        [bookWidgetAem]="bookWidgetAem"
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="!isDesktop"
        [predictiveSearchData]="predictiveSearchData"
        [datepickerConfig]="datepickerConfig"
        (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
        (swapClicked)="swapAirports.emit($event)"
        (findFlight)="onFindFlightClick()"
        (searchModalEvent)="searchModalEvent.emit($event)"
        (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      ></idp-apps-book-widget-desktop-ow-rt>
      <idp-multi-city-desktop-advance
        *ngIf="
          bookWidgetFields?.tripTypesField?.selectedTripType ===
          tripTypeOptions.MULTI_CITY
        "
        [bookWidgetFields]="bookWidgetFields"
        [bookWidgetAem]="bookWidgetAem"
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="!isDesktop"
        [predictiveSearchData]="predictiveSearchData"
        [datepickerConfig]="datepickerConfig"
        (addFlight)="addFlightsForMc.emit()"
        (removeFlight)="removeFlightForMc.emit()"
        (swapClicked)="swapAirports.emit($event)"
        (findFlight)="onFindFlightClick()"
        (searchModalEvent)="searchModalEvent.emit($event)"
        (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
        (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
        (infoIconClick)="infoIconClickHandler($event)"
      ></idp-multi-city-desktop-advance>
    </ng-container>
    <ng-template #desktopSkeleton>
      <idp-apps-book-widget-desktop-skeleton></idp-apps-book-widget-desktop-skeleton>
    </ng-template>
  </ng-template>

  <ng-template #mobileView>
    <ng-container
      *ngIf="
        isBookWidgetReady && bookWidgetFields && bookWidgetAem;
        else mobileSkeleton
      "
    >
      <idp-apps-book-widget-mobile-ow-rt
        *ngIf="
          bookWidgetFields?.tripTypesField?.selectedTripType !==
          tripTypeOptions.MULTI_CITY
        "
        (infoIconClick)="infoIconClickHandler($event)"
        [bookWidgetFields]="bookWidgetFields"
        [bookWidgetAem]="bookWidgetAem"
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="!isDesktop"
        [predictiveSearchData]="predictiveSearchData"
        [datepickerConfig]="datepickerConfig"
        (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
        (swapClicked)="swapAirports.emit($event)"
        (findFlight)="onFindFlightClick()"
        (searchModalEvent)="searchModalEvent.emit($event)"
        (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
      ></idp-apps-book-widget-mobile-ow-rt>
      <idp-multi-city-mobile-advance
        *ngIf="
          bookWidgetFields?.tripTypesField?.selectedTripType ===
          tripTypeOptions.MULTI_CITY
        "
        [bookWidgetFields]="bookWidgetFields"
        [bookWidgetAem]="bookWidgetAem"
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="!isDesktop"
        [predictiveSearchData]="predictiveSearchData"
        [datepickerConfig]="datepickerConfig"
        (addFlight)="addFlightsForMc.emit()"
        (removeFlight)="removeFlightForMc.emit()"
        (swapClicked)="swapAirports.emit($event)"
        (findFlight)="onFindFlightClick()"
        (searchModalEvent)="searchModalEvent.emit($event)"
        (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
        (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
        (infoIconClick)="infoIconClickHandler($event)"
      ></idp-multi-city-mobile-advance>
    </ng-container>
    <ng-template #mobileSkeleton>
      <idp-apps-book-widget-mobile-skeleton></idp-apps-book-widget-mobile-skeleton>
    </ng-template>
  </ng-template>

  <idp-info-popup-modal
    #infoPopUpModal
    [content]="infoPopUpModalData"
    (exit)="infoPopUpModal.closeModal(true)"
  ></idp-info-popup-modal>
</div>
